import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

const notOnlySpacesAndRequiresAlphaNumeric = yup
  .string()
  .required(DEFAULT_MESSAGES.REQUIRED)
  .test(
    "is-not-blank",
    "Este campo no puede estar vacío o contener solo espacios.",
    value => !!value && value.trim().length > 0 && /[A-Za-z0-9]/.test(value)
  );

export const createCertificacionesSchema = yup.object({
  nombre: notOnlySpacesAndRequiresAlphaNumeric,
  descripcion: yup.string().optional(),
});
